import { FC, useRef } from "react";

import { cn } from "@src/lib/utils/cn";
import { RadioGroupItem } from "@src/lib/ui/RadioGroup";

type Props = {
  className?: string;
  testId?: string;
  value: string;
  children: React.ReactNode;
  disabled?: boolean;
  selected?: boolean;
  // Hide the visual radio dot for card-only designs. Screen readers
  // still see it (sr-only preserves the radio role + keyboard nav).
  hideIndicator?: boolean;
};

const RadioGroupChoiceboxItem: FC<Props> = ({
  className,
  testId,
  value,
  children,
  disabled,
  selected,
  hideIndicator,
}) => {
  const itemRef = useRef<HTMLButtonElement>(null);
  return (
    <div
      className={cn(
        "flex items-center rounded-md border border-input bg-background p-2 ring-offset-background ",
        disabled
          ? "cursor-not-allowed [&>*]:cursor-not-allowed"
          : "cursor-pointer [&>*]:cursor-pointer",
        hideIndicator &&
          "focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2",
        className,
        selected ? "border-primary" : "",
      )}
      onClick={() => {
        if (itemRef.current) {
          itemRef.current.click();
        }
      }}
    >
      {children}
      <RadioGroupItem
        disabled={disabled}
        data-testid={testId ? testId : undefined}
        className={cn("ml-auto", hideIndicator && "sr-only")}
        value={value}
        ref={itemRef}
      />
    </div>
  );
};

export default RadioGroupChoiceboxItem;
